import React, { useState } from "react";
import Modal from "react-modal";
import "../css/SelectJobModal.css";

const JobComments = ({ theme, openJobComments, setOpenJobComments, route_uuid, job_comments, add_comments }) => {

    const [newComment, setNewComment] = useState(job_comments?? null);
    const [error, setError] = useState("");

    const handleAddComments = () => {
        if (!newComment) {
            setError("Please add your comments to this job.");
        } else {
            setError("");

            add_comments(newComment, route_uuid);
            setOpenJobComments(false);
        }
    };

    return (
        <Modal
        id={theme}
            isOpen={openJobComments}
            onRequestClose={() => setOpenJobComments(false)}
            ariaHideApp={false}
            style={{
                overlay: {
                    zIndex: 99999,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                },
                content: {
                    margin: "auto",
                    justifyContent: "center",
                    display: "flex",
                    backgroundColor: "transparent",
                    border: "none",
                    zIndex: 100000,
                    height: "500px",
                }
            }}
        >
            <div className={`${theme} modal-container`}>
                <h2>Add Comments To Job</h2>

                <div className="manual-inputs">
                    <label htmlFor="newComment">Add Comment:</label>
                    <input
                        id="newComment"
                        type="text"
                        className="input"
                        value={newComment}
                        onChange={(e) => setNewComment(e.target.value)}
                    />

                </div>

                {error && <p className="error-message">{error}</p>}

                <div className="button-group">
                    <button className="add-button" onClick={handleAddComments}>
                        Add Comment
                    </button>
                    <button
                        className="close-button"
                        onClick={() => setOpenJobComments(false)}
                    >
                        Close
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default JobComments;
